import React from "react";
import { useAuth } from "../context/AuthContext.js";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaLink,
} from "react-icons/fa";

const Curriculum = ({ profileData }) => {
  const { currentUser } = useAuth();

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=https://apimys.com/curriculum/${currentUser?.uid || ''}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=https://apimys.com/curriculum/${currentUser?.uid || ''}`,
    x: `https://x.com/intent/tweet?text=Visitá%20mi%20currículum%20en%20Apimys!%20https://apimys.com/curriculum/${currentUser?.uid || ''}`,
    whatsapp: `https://api.whatsapp.com/send?text=Visitá%20mi%20currículum%20en%20Apimys!%20https://apimys.com/curriculum/${currentUser?.uid || ''}`,
  };
  return (
    <div className="tab-content">
      <h3>Mi Currículum</h3>
      <p>
        <strong>Habilidades:</strong> {profileData.skills}
      </p>
      <p>
        <strong>Experiencia:</strong> {profileData.experience}
      </p>
      <p>
        <strong>Remuneración requerida:</strong> {profileData.salary}
      </p>
      <p>
        <strong>Tipo de experiencia buscada:</strong> {profileData.jobExpectations}
      </p>
      <h4>Videocurriculum:</h4>
      {profileData.videos.map((video, index) => (
        <div key={index}>
          <video 
            src={video} 
            controls 
            style={{ maxWidth: "300px", width: "100%" }} 
          />
        </div>
      ))}
      <div className="iconos-refs-c">
        <ul className="wrapper-icons sci">
          <li className="icon-c comentarios">
              <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer">
              <span><FaFacebook /></span>
              </a>
          </li>
          <li className="icon-c comentarios">
              <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer">
              <span><FaLinkedin /></span>
              </a>
          </li>
          <li className="icon-c comentarios">
              <a href={shareLinks.x} target="_blank" rel="noopener noreferrer">
              <span><i className="fa-brands fa-x-twitter"></i></span>
              </a>
          </li>
          <li className="icon-c comentarios">
              <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer">
              <span><FaWhatsapp /></span>
              </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Curriculum;
